import React from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';

import RegistrationForm from './registration-form';
import './registration-page.css';

export function RegistrationPage(props) {
    // If we are logged in (which happens automatically when registration
    // is successful) redirect to the user's dashboard
    if (props.loggedIn) {
        return <Redirect to="/dashboard" />;
    }
    return (
        <div>
            <p>A place to learn basic sign language...</p>
            <p>because everyone needs to be heard.</p>
            <div className="overlay"></div>
            <div className="overlay2"></div>
            <div className="home">
                <h2>Join the movement to hear everyone!</h2>
                <RegistrationForm />
                <Link to="/login">Login</Link>
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    loggedIn: state.auth.currentUser !== null
});

export default connect(mapStateToProps)(RegistrationPage);



// WEBPACK FOOTER //
// ./src/components/registration-page.js